
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sallad",
      function () {
        return require("private-next-pages/sallad/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sallad"])
      });
    }
  